export default __webpack_public_path__ + "static/media/slide2.abf56d04.jpg";